import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import usePermissions from "../hooks/UsePermissions";

const ProtectedRoute = ({ Element, module }) => {
  const token = useSelector((state) => state.tokens?.token);
  const checkPermission = usePermissions();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (module) {
    const hasAccess = checkPermission(module, "view"); // Check view permission
    if (!hasAccess) {
      return <Navigate to="/not-authorized" replace />;
    }
  }

  return <Element />;
};

export default ProtectedRoute;

